<template>
  <v-row>
    <v-col cols="2" class="pt-0 pb-1">
      <v-combobox v-model="itenary.from" :items="airports" item-value="code" item-text="code" label="Départ de"
                  :filter="filterAirport" autocomplete="new-password" hide-details @change="airportChange('from')"
                  :return-object="false">
        <template v-slot:item="data">
          <v-list-item-content>
            <v-list-item-title>
              <span class="font-weight-bold">{{ data.item.code }} <span
                  v-if="data.item.cityCode">({{ data.item.cityCode }})</span></span></v-list-item-title>
            <v-list-item-subtitle>
              {{ data.item.name }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-combobox>
    </v-col>
    <v-col cols="2" class="pt-0 pb-1">
      <v-combobox v-model="itenary.to" :items="airports" item-value="code" item-text="code" label="Arrivé à"
                  :filter="filterAirport" autocomplete="new-password" hide-details @change="airportChange('to')"
                  :return-object="false">
        <template v-slot:item="data">
          <v-list-item-content>
            <v-list-item-title>
              <span class="font-weight-bold">{{ data.item.code }} <span
                  v-if="data.item.cityCode">({{ data.item.cityCode }})</span></span></v-list-item-title>
            <v-list-item-subtitle>
              {{ data.item.name }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-combobox>
    </v-col>

    <v-col class="pt-0 pb-1" style="max-width: 130px;">
      <v-select v-model="itenary.dateCtx" :items="dateCtxs" item-value="code" item-text="name" hide-details/>
    </v-col>
    <v-col cols="1" class="pa-1" align-self="end">
      <smart-picker
        v-model="itenary.date"
        :next-picker="$refs.bookingStopDatePicker"
        :picker-date="itenary.date"
        format="dd/MM/yyyy"
        :startDate="itenary.date"
        :pickerOptsmail="pickerOpts" :textFieldOpts="textFieldOpts" :label="dateCtxLabel" :hideDetails="false"
      ></smart-picker>
    </v-col>
    <v-col class="pt-0 pb-1">
      <v-text-field v-model="time" label="Heure départ" clearable v-mask="'##:##'" style="max-width: 100px"/>
    </v-col>
    <v-col class="pt-0 pb-1">
      <v-text-field v-model.number="timeWindow" type="number" label="+/-(1-12)H" :min="1" :max="12" clearable style="max-width: 90px"/>
    </v-col>
    <v-spacer/>
    <v-col cols="2" class="pt-0 pb-1">
      <v-select v-model="itenary.travelClass" :items="travelClasses" label="Classe de vol" hide-details/>
    </v-col>
  </v-row>
</template>
<script>

import * as date from "date-fns"

export default {
  components: {
  },
  props: {
    itenary: {type: Object, required: true},
    itenaryIndex: {type: Number, default: 0},
    airports: {type: Array, default: () => []},
    travelClasses: {type: Array, default: () => []}
  },
  directives: {

  },
  data: () => ({
    dateCtxs: [
      {code: 'Departure', name: 'Départ le'},
      {code: 'Arrival', name: 'Arrivée le'}
    ],
    pickerOpts: {
      'no-title': true
    },
    textFieldOpts: {},
  }),
  computed: {
    date: {
      get() {
        try {
          return date.format(date.parse(this.itenary.date, "dd/MM/yyyy", new Date()), "yyyy-MM-dd")
        } catch (e) {
          return null;
        }
      },
      set(newVal) {
        this.itenary.date = date.format(date.parse(newVal, "yyyy-MM-dd", new Date()), "dd/MM/yyyy")
      }
    },
    time: {
      get() {
        try {
          return this.itenary.timeRange.time
        } catch (e) {
          return null;
        }
      },
      set(newVal) {
        if (newVal == null) {
          this.itenary.timeRange = null;
          return
        }
        this.itenary.timeRange = {...(this.itenary.timeRange || {hoursAround:1}), time: newVal}
      }
    },
    timeWindow: {
      get() {
        try {
          if (!this.itenary.timeRange){ return null}
          return parseInt(this.itenary.timeRange.hoursAround)
        } catch (e) {
          return null;
        }
      },
      set(newVal) {
        this.itenary.timeRange = {...(this.itenary.timeRange || {}), hoursAround: newVal}
      }
    },
    dateCtxIcon() {
      return this.itenary.dateCtx === 'Arrival' ? 'mdi-airplane-landing' : 'mdi-airplane-takeoff'
    },
    dateCtxLabel() {
      return this.itenary.dateCtx === 'Arrival' ? 'Date d\'arrivée' : 'Date de départ'
    },
  },
  methods: {
    changeDateCtx() {
      this.itenary.dateCtx = this.itenary.dateCtx === 'Arrival' ? 'Departure' : 'Arrival'
    },
    filterAirport(item, query, itemText) {

      const querylc = query.toLocaleLowerCase()

      return item.code.toLocaleLowerCase().indexOf(querylc) > -1 || item.name.toLocaleLowerCase().indexOf(querylc) > -1
    },
    airportChange(airportType) {
      this.$emit('airportChange', this.itenaryIndex, airportType, this.itenary[airportType])
    }
  }
}
</script>